module.exports = __webpack_public_path__ + "static/media/4.4dc5a92e.png";